import { useOutletContext } from 'react-router-dom'
import { useSignal } from '@preact/signals-react'

import Button from 'react-bootstrap/Button'
import Form from 'react-bootstrap/Form'

import OrganizationAppConfigModal from './OrganizationAppConfigModal.jsx'

import { currentBusinessEntitySignal } from '../../../../state/signals/businessEntitySignals.js'

import { hasPermission } from '../../../../utils/utils.js'

const ShowOrganizationForm = function ({ organizationSignal, disallowEditSignal, organizationNameSignal, inactivityExpirationSignal, originalInactivityExpirationSignal }) {

	const { user, config, accessToken, userPermissions, userPermissionsSummary, accordionData: sidebarAccordionData } = useOutletContext()

	const showOrganizationAppConfigModalSignal = useSignal(false)

	const showModalOrganizationAppConfig = function () {
		showOrganizationAppConfigModalSignal.value = true
	}

	const applyConfig = function () {
		window.alert("Entered ShowOrganizationForm.applyConfig")
	}

	const updateOrganizationName = (event) => {
		organizationNameSignal.value = event.target.value
	}

	const canViewInactivity = hasPermission(userPermissions, "Organizations", "canView")
	const canEditInactivity = hasPermission(userPermissions, "Organizations", "canEdit")

	const inactivityInputSignal = useSignal(String(inactivityExpirationSignal.value))
	const inactivityErrorSignal = useSignal(false)

	const updateInactivityExpiration = (event) => {
		inactivityInputSignal.value = event.target.value
		inactivityErrorSignal.value = false
	}

	const commitInactivityExpiration = () => {
		const val = parseInt(inactivityInputSignal.value, 10)
		if (!isNaN(val) && val >= 180 && val <= 365) {
			inactivityExpirationSignal.value = val
			inactivityErrorSignal.value = false
			inactivityInputSignal.value = String(val)
		} else {
			inactivityErrorSignal.value = true
			inactivityInputSignal.value = String(originalInactivityExpirationSignal.value)
		}
	}

	return (
		<>
			<Form.Group className="mt-3">
				<Form.Label htmlFor="organizationName">Name</Form.Label>
				<Form.Control type="text" defaultValue={currentBusinessEntitySignal.value.name} id="organizationName" name="organizationName" maxLength="50" required disabled={disallowEditSignal.value} spellCheck={false} autoComplete="off" autoCapitalize="off" autoCorrect="off" onKeyUp={updateOrganizationName} />
			</Form.Group>
			{canViewInactivity && (
				<Form.Group className="mt-3">
					<Form.Label htmlFor="inactivityExpiration">Machine Inactivity Expiration (days)</Form.Label>
					<Form.Control type="number" id="inactivityExpiration" name="inactivityExpiration" min={180} max={365} required disabled={!canEditInactivity} value={inactivityInputSignal.value} onChange={updateInactivityExpiration} onBlur={commitInactivityExpiration} isInvalid={inactivityErrorSignal.value} />
					{inactivityErrorSignal.value && (
						<Form.Text className="text-danger">Accepted values are between 180 and 365 days.</Form.Text>
					)}
				</Form.Group>
			)}
			{
				hasPermission(userPermissions, "appRecord", "canView") && (
					<>
						<Form.Group>
							<Form.Label htmlFor="connectedTo">Domains &amp; App Names</Form.Label>
							<div className="button-container">
								<Button className={"float-start"} onClick={showModalOrganizationAppConfig}>Configure</Button>
							</div>
						</Form.Group>
						<OrganizationAppConfigModal
							showSignal={showOrganizationAppConfigModalSignal}
							cancelConfig={() => { showOrganizationAppConfigModalSignal.value = false } }
							applyConfig={applyConfig}
							organization={organizationSignal.value}
						></OrganizationAppConfigModal>
					</>
				)
			}
		</>
	)
}
export default ShowOrganizationForm
